/**
 * Profils de l'équipe d'un séjour et QR de démarrage.
 * Le premier membre (AS ou direction) rejoint le séjour avec un lien à usage unique ;
 * les suivants sont invités depuis l'app, par un membre de l'équipe sanitaire.
 */

/** Lien du QR de démarrage. Les anciennes versions de l'app ignorent le paramètre `init`. */
export const startupLink = (publicWebsite, unitId, initToken) =>
    `${publicWebsite}/register_in_organism?orga_id=${encodeURIComponent(unitId)}&init=${encodeURIComponent(initToken)}`

/** Libellé du profil d'un appareil. Sans `access` (ancienne API) : accès complet. */
export const accessLabel = (access) => (access === 'team' ? 'Animation' : 'Équipe sanitaire')

/** Le séjour est démarré dès qu'il a une clé, c'est-à-dire qu'un premier membre l'a rejoint. */
export const isUnitStarted = (unit) => Boolean(unit?.url)
